import React from "react";

export const Article = (props) => {
  const tstyle = {
    fontSize: "4rem",
    marginBottom: "1em",
    color: "#606060",
    textAlign: "center",
    textDecoration: "underline",
    textDecorationThickness: "0.01em",
    textDecorationColor: "#606060",
  };
  const pstyle = {
    fontSize: "22px",
    marginBottom: "1em",
    color: "#606060",
    fontFamily: "Arial",
    textAlign: 'justify',  
    textIndent: '2em',     
    lineHeight: '1.3',     
  };
  const cstyle = {
    backgroundColor: props.data?.backgroundColor || "white",
    color: "#606060",
    marginBottom: "1em",
    padding: "4em",
  };
  return (
    <div id={props?.anchor} style={cstyle}>
      <div className="container" >
          <div className="row">
            <div className="col-xs-12 col-md-5">
              {" "}
            </div>
            <div className="col-xs-12 col-md-7">
              <h2 style={tstyle}>{props.data?.title}</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-md-5">
              {" "}
              <img src={props.data?.img} className="img-responsive" alt="" />{" "}
            </div>
            <div className="col-xs-12 col-md-7">
              <div className="about-text">
                <p style={pstyle}>{props.data ? props.data?.p1 : "loading..."}</p>
                <p style={pstyle}>{props.data ? props.data?.p2 : "loading..."}</p>
                <p style={pstyle}>{props.data ? props.data?.p3 : "loading..."}</p>
              </div>
            </div>
        </div>
      </div>
    </div>
  );
};
